;;;if ($('.type-detail').length) {


    var hasVariants = $('.variant-list').length > 0;
    var buttonHtml = '';

    if (hasVariants) {
        buttonHtml = `<span class="customBtnVariant btn btn-primary">${translation('vybrat_variantu')}</span>`;
    } else {
        buttonHtml = `<span class="customBtnCart btn btn-conversion" data-priceId="${$('#product-detail-form>input[name="priceId"]').val()}">${translation('koupit')}</span>`;
    }
    var cloneList = $('ul#p-detail-tabs').html()
    var customLineCart = `
        <div class="left">
            <img src="${$('.p-image a.p-main-image').attr('href')}" alt="${$('.p-detail-inner>.p-detail-inner-header>h1').text()}">
        </div>
        <div class="center">
            <p>${$('.p-detail-inner>.p-detail-inner-header>h1').html()}<p>
            <ul class="" id="p-detail-tabs">${cloneList}</ul>
        </div>
        <div class="right">
            <div class="priceStock">
                <div class="pricesLine">${$('.p-final-price-wrapper').html()}</div>
                <div class="availabilityCustom">${$('.availability-value').html()}</div>
            </div>
            <div class="buyButton">${buttonHtml}</div>
        </div>
    `;

    $('footer#footer').after('<div class="detailFixedCart" style="display:none;"><div class="container">'+customLineCart+'</div></div>');

   
$('html').on('click', '.customBtnCart', function(){
    shoptet.cartShared.addToCart({priceId: $(this).attr('data-priceId'), amount: 1});
})
    





document.addEventListener('ShoptetVariantAvailable', function() {
    if(!$('body.disabled-add-to-cart').length){
         $('.priceStock .pricesLine').html($('.p-final-price-wrapper').html());
    $('.availabilityCustom').html($('.p-info-wrapper .availability-value').closest('th').html())

    setTimeout(function(){
    $('.detailFixedCart .right .buyButton').html(`
        <span class="customBtnCart btn btn-conversion" data-priceId="${$('#product-detail-form>input[name="priceId"]').val()}">${translation('koupit')}</span>
    `)
    console.log($('#product-detail-form>input[name="priceId"]').val())
    }, 250)
    }
    
});

 // scroll na varianty
    $(document).on('click', '.customBtnVariant', function () {
        var top = $('.variant-list').offset().top - 60;

        $('html, body').animate({
            scrollTop: top
        }, 400);
    });

$(window).on('scroll', function () {

  

        var scrollTop = $(window).scrollTop();

        var triggerOffset =
            $('.p-detail-tabs-wrapper').offset().top + 150;

        if (scrollTop >= triggerOffset) {
            $('.detailFixedCart').fadeIn();
        } else {
            $('.detailFixedCart').fadeOut();
        }

    });


}